import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Menu } from 'primereact/menu'
import type { MenuItem } from 'primereact/menuitem'
import Button from '../../../components/ui/Button'
import type { PrincipleDecision } from '../types'

interface Props {
  row: PrincipleDecision
  canManage: boolean
  onStakeholders: (row: PrincipleDecision) => void
  /** Dosyalar pop-up'ını açar (108) — yetkiden bağımsız: okuma yetkisi olan da dosyayı görüp indirir. */
  onFiles: (row: PrincipleDecision) => void
  onEdit: (row: PrincipleDecision) => void
  onDelete: (row: PrincipleDecision) => void
}

/**
 * Mobil kart satır işlemleri — 3 nokta (kebab) ile açılan popup menü (`DeadlineRequestRowActions`
 * emsali; kullanıcı isteği: ayrı ikon butonları yerine tek dropdown). Düzenle/Sil yalnız
 * `canManage` iken menüde görünür (yazma yetkisi olmayan kullanıcı yalnız Paydaşlar'ı görür).
 */
export default function PrincipleDecisionRowActions({
  row,
  canManage,
  onStakeholders,
  onFiles,
  onEdit,
  onDelete,
}: Readonly<Props>) {
  const { t } = useTranslation()
  const menuRef = useRef<Menu>(null)

  const items: MenuItem[] = [
    {
      label: t('principleDecisions.actions.stakeholders'),
      icon: 'pi pi-users',
      command: () => onStakeholders(row),
    },
    {
      label: t('principleDecisions.actions.files'),
      icon: 'pi pi-paperclip',
      command: () => onFiles(row),
    },
    ...(canManage
      ? [
          {
            label: t('principleDecisions.actions.edit'),
            icon: 'pi pi-pencil',
            command: () => onEdit(row),
          },
          {
            label: t('principleDecisions.actions.delete'),
            icon: 'pi pi-trash',
            command: () => onDelete(row),
          },
        ]
      : []),
  ]

  return (
    <>
      {/* Panel kartın DIŞINA çizilir: kart içinde kalırsa son satırlarda kırpılır. */}
      <Menu model={items} popup ref={menuRef} appendTo={document.body} />
      <Button
        type="button"
        text
        rounded
        icon="pi pi-ellipsis-v"
        aria-label={t('principleDecisions.actions.actionsMenu')}
        aria-haspopup
        onClick={(e) => menuRef.current?.toggle(e)}
      />
    </>
  )
}
